var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgClipboardMarkWithBackground = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 120 120"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clipboard-mark-with-background_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#FAFA64",
  d: "M60 119.586c26.11 0 40.626 0 50.106-9.48s9.48-23.996 9.48-50.106 0-40.626-9.48-50.106S86.111.414 60 .414c-26.11 0-40.626 0-50.106 9.48S.414 33.89.414 60s0 40.626 9.48 50.106 23.996 9.48 50.106 9.48"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#CA3051",
  d: "M63.572 60.246c2.646-9.697 7.239-25.175-3.052-25.175-3.39 0-5.725 2.156-5.725 7.175 0 8.435.019 29.377.019 34.471 0 2.624.521 7.734 5.706 7.734 3.734 0 6.157-2.12 6.157-7.734v-5.876h12.236c0 7.074.496 25.716-18.393 25.716-4.837 0-19.436-1.89-19.436-21.766l.012-30.22c0-17.826 11.653-21.123 19.424-21.123 15.726 0 23.048 12.711 15.254 36.8H63.572z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FAFA64",
  d: "M60 119.586c26.11 0 40.626 0 50.106-9.48s9.48-23.996 9.48-50.106 0-40.626-9.48-50.106S86.111.414 60 .414c-26.11 0-40.626 0-50.106 9.48S.414 33.89.414 60s0 40.626 9.48 50.106 23.996 9.48 50.106 9.48"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#33191B",
  d: "M63.572 60.246c2.646-9.697 7.239-25.175-3.052-25.175-3.39 0-5.725 2.156-5.725 7.175 0 8.435.019 29.377.019 34.471 0 2.624.521 7.734 5.706 7.734 3.734 0 6.157-2.12 6.157-7.734v-5.876h12.236c0 7.074.496 25.716-18.393 25.716-4.837 0-19.436-1.89-19.436-21.766l.012-30.22c0-17.826 11.653-21.123 19.424-21.123 15.726 0 23.048 12.711 15.254 36.8H63.572z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clipboard-mark-with-background_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h120v120H0z"
})))));
export default SvgClipboardMarkWithBackground;